import * as Yup from 'yup';

import { JobSiteFormData } from '@/jobSites/application/types/JobSiteTypes';
import { createLocationFormValidationSchema, LocationFormData } from '@/map/presentation/LocationForm/validationSchema';

// Validation schema factory that creates schema based on whether it's a new record or edit
export const createJobSiteValidationSchema = (isNew: boolean) => {
  return Yup.object<JobSiteFormData>({
    // first section
    id: Yup.number().nullable(),

    // Customer is required only when creating a new JobSite
    customerId: isNew ? Yup.number().required('Customer is required') : Yup.number().nullable().optional(),
    jobSiteName: Yup.string()
      .nullable()
      .optional()
      .test('min-length', 'Job Site Name must be at least 3 characters', function (value) {
        // Only validate min length if value is provided and not empty
        if (value == null || value === '') {
          return true;
        }
        return value.length >= 3;
      })
      .max(255, 'Job Site Name must be at most 255 characters'),
    jobSiteTypeId: Yup.number().required('Job Site Type is required'),
    jobPhone: Yup.string().optional().max(50, 'Phone number must be at most 50 characters'),

    // Location fields - use LocationFormValidationSchema with required coordinates for JobSites
    ...createLocationFormValidationSchema(true).fields,

    // third section
    notes: Yup.string().max(255),
    specialInstructions: Yup.string().max(2000)
  });
};

export const JobSiteValidationSchema = createJobSiteValidationSchema(true);

export const JobSiteModalValidationSchema = Yup.object().shape({
  jobSiteName: Yup.string(),
  jobPhone: Yup.string().optional().max(50, 'Phone number must be at most 50 characters'),
  specialInstructions: Yup.string().max(2000),
  ...createLocationFormValidationSchema(false).fields
});

export type JobSiteModalFormData = {
  jobSiteName: string;
  jobPhone?: string;
  specialInstructions?: string;
} & LocationFormData;
